import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers, RequestMethod, URLSearchParams } from "@angular/http";
import { Observable } from "rxjs";
import { Subject } from 'rxjs/Subject';
import { Router } from "@angular/router";

@Injectable()
export class ApiLocauxService {
  protected _apiUrlBase = environment.base_api;
  public datasFilter;

  protected localFormDatasSubject = new Subject<any>();
  public localFormDatas;

  constructor(private _http : Http, private router : Router) { 
    this.localFormDatasSubject.asObservable().subscribe( data => {
      this.localFormDatas = data;
      localStorage.setItem('vvad-form-local', JSON.stringify(data));
    });
  }

  setLocalFormDatas(datas) 
  {
    this.localFormDatasSubject.next(datas);
  }

  getLocalFormDatas() {
    if(this.localFormDatas === undefined) {
      return JSON.parse(localStorage.getItem('vvad-form-local'));
    } else {
      return this.localFormDatas;
    }
  }

  initializeFormAnnuaire() : Promise<any> {
    return new Promise((resolve, reject) => {
      this._http
          .get(this._apiUrlBase+'/locaux/initialize')
          .subscribe(response => {
            let results = response.json();

              resolve(results.payload);
          })
    })
  }

  getCommunesByTerritoire(idTerritoire) : Promise<any> {
    return new Promise((resolve, reject) => {
      this._http
          .get(this._apiUrlBase+'/locaux/territoires/communes/'+idTerritoire)
          .subscribe(response => {
            let results = response.json();

              resolve(results.payload);
          })
    })
  }

  getLocauxByFilter(offset) : Promise<any> {
    let body = new URLSearchParams();
    let result;

    body.set('filters', JSON.stringify(this.getLocalFormDatas()));
    body.set('offset', offset);

    return new Promise((resolve, reject) => {
      this._http
        .post(this._apiUrlBase+'/locaux/filter', body)
        .subscribe(response => {
          console.log('- GET LOCAUX - ', response);
          let entreprises = response.json();
          resolve(entreprises.payload);
        })
      })
  }

  getLocal(id) : Promise<any> {
    return new Promise((resolve, reject) => {
      this._http
          .get(this._apiUrlBase+'/locaux/get/'+id)
          .subscribe(response => {
            let results = response.json();

              resolve(results.payload);
          })
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/locaux/services/api-locaux.service.ts